var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBnbLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#F3BA2F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17536_54189)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7274 14.2446L15.9998 9.97233L20.2744 14.2468L22.7604 11.7608L15.9998 5L9.24153 11.7586L11.7274 14.2446ZM5 15.9997L7.48608 13.5136L9.97199 15.9995L7.48593 18.4856L5 15.9997ZM11.7274 17.7554L15.9998 22.0277L20.2743 17.7533L22.7616 20.238L22.7604 20.2393L15.9998 27L9.24131 20.2416L9.23779 20.2381L11.7274 17.7554ZM22.0281 16.001L24.5142 13.515L27.0001 16.0009L24.514 18.4869L22.0281 16.001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.521 15.9992H18.5221L15.9994 13.4766L14.1351 15.3408H14.135L13.9209 15.5551L13.4791 15.997L13.4756 16.0004L13.4791 16.004L15.9994 18.5245L18.5221 16.0018L18.5233 16.0004L18.521 15.9992Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17536_54189"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBnbLogo);
export default __webpack_public_path__ + "static/media/BNBLogo.0440a2c2.svg";
export { ForwardRef as ReactComponent };